export enum StickyTabsUnitSpecifications {
    UNITS = 'units',
    DRAWER = 'drawer',
    WIREWORK = 'wirework',
    COLOUR = 'colour'
};
